import React, { useEffect, useState } from "react";
import {
  Heart,
  Activity,
  Thermometer,
  Candy,
  Hamburger,
  Beef,
} from "lucide-react";
import { HealthStatsData, HealthStatsProps } from "../../types";
import { authHeaders } from "../../lib/auth";

export const HealthStats: React.FC<HealthStatsProps> = ({ refreshTrigger }) => {
  const [stats, setStats] = useState<HealthStatsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch(
          `${import.meta.env.VITE_API_BASE}/api/health/stats`,
          { headers: authHeaders() },
        );
        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("❌ Fetch health stats error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [refreshTrigger]);

  const healthIndicators = [
    {
      title: "Tekanan Darah Normal",
      value: "120/80 mmHg",
      icon: Heart,
      bgColor: "bg-red-100",
      iconColor: "text-red-600",
    },
    {
      title: "Detak Jantung Normal",
      value: "60 - 100 bpm",
      icon: Activity,
      bgColor: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      title: "Suhu Tubuh Normal",
      value: "36,1 - 37,2 °C",
      icon: Thermometer,
      bgColor: "bg-orange-100",
      iconColor: "text-orange-600",
    },
    {
      title: "Gula Darah Normal",
      value: "70 - 99 mg/dL",
      icon: Candy,
      bgColor: "bg-pink-100",
      iconColor: "text-pink-600",
    },
    {
      title: "Kolesterol Normal",
      value: "< 100 mg/dL",
      icon: Hamburger,
      bgColor: "bg-yellow-100",
      iconColor: "text-yellow-600",
    },
    {
      title: "Asam Urat Normal",
      value: (
        <>
          <div>Pria: 2,5 – 7,0 mg/dL</div>
          <div>Wanita: 1,5 – 6,0 mg/dL</div>
        </>
      ),
      icon: Beef,
      bgColor: "bg-red-200",
      iconColor: "text-red-700",
    },
  ];

  if (loading) return <p className="text-gray-500">Loading statistik...</p>;
  if (!stats) return <p className="text-gray-500">Belum ada data statistik</p>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {healthIndicators.map((item) => {
        const Icon = item.icon;

        return (
          <div
            key={item.title}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">
                  {item.title}
                </p>
                <p className="text-xl font-bold text-gray-900">{item.value}</p>
              </div>

              <div className={`p-3 rounded-lg ${item.bgColor}`}>
                <Icon className={`h-6 w-6 ${item.iconColor}`} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
